export enum Season {
  SPRING = "Spring",
  SUMMER = "Summer",
  FALL = "Fall",
  WINTER = "Winter",
}

export enum Weather {
  SUNNY = "Sunny",
  RAINY = "Rainy",
  WINDY = "Windy",
}

export enum Location {
  OCEAN = "Ocean",
  MOUNTAIN_LAKE = "Mountain Lake",
  FOREST_POND = "Forest Pond",
  RIVER = "River",
  FOREST_FARM_POND = "Forest Farm Pond",
  TOWN_RIVER = "Town River",
  FOREST_RIVER = "Forest River",
  WILDERNESS = "Wilderness",
  SECRET_WOODS = "Secret Woods",
  THE_SEWER = "The Sewer",
  MUTANT_BUG_LAIR = "Mutant Bug Lair",
  WITCH_SWAMP = "Witch's Swamp",
  MINES_F20 = "The Mines: Floor 20",
  MINES_F60 = "The Mines: Floor 60",
  MINES_F100 = "The Mines: Floor 100",
  CRIMSONFISH = "East pier on the beach",
  ANGLER = "North of Jojomart, on the wooden plank bridge",
  LEGEND = "Mountain Lake, near the big log",
  DESERT = "The Desert",
  GLACIERFISH = "Southend of arrowhead island in Cindersap forest",
  GINGER_ISLAND = "Ginger Island",
  GINGER_ISLAND_POND = "Ginger Island Pond",
  GINGER_ISLAND_RIVER = "Ginger Island River",
  CRAB_POT_OCEAN = "Crab Pot: Ocean",
  CRAB_POT_FRESHWATER = "Crab Pot: Freshwater",
  NIGHT_MARKET = "Night market",
  PIRATE_COVE = "Pirate Cove",
}

export const AllSeasons: Season[] = [
  Season.SPRING,
  Season.SUMMER,
  Season.FALL,
  Season.WINTER,
];
export const AllWeather: Weather[] = [
  Weather.SUNNY,
  Weather.RAINY,
  Weather.WINDY,
];
